import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.62 5.99L10 8h4l-1.6-2.01c-.2-.25-.58-.25-.78 0zM18 10v4l2.01-1.6c.25-.2.25-.58 0-.78L18 10zM6 10l-2.01 1.62c-.25.2-.25.58 0 .78L6 14v-4zm8 6h-4l1.62 2.01c.2.25.58.25.78 0L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16.01H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.02c0 .55-.45 1-1 1z"
}), 'SettingsOverscanRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SettingsOverscanRounded.js
// module id = 6057
// module chunks = 2